import draftToHtml from 'draftjs-to-html';
import parse from 'html-react-parser';
import React, { useEffect, useState } from 'react';
import { isEnglish } from '../_helpers';
import { apiConstants } from '../_constants';
import { examService } from '../_services/exam.service';

export const AnswerSheet = ({ mocktest_id }) => {
  const [answerSheetData, setAnswersheetData] = useState([]);

  useEffect(() => {
    getAnswerSheet();
  }, []);
  const getAnswerSheet = () => {
    const query = {
      mocktest_id: mocktest_id,
    };
    examService.getMockTestAnswerSheet(query).then(
      (res) => {
        setAnswersheetData(res.data);
        console.log(res, 'this is res');
      },
      (err) => {
        console.log(err, 'this is error data');
      },
    );
  };

  //   const ContentRenderer = (contentState, questionindex) => {
  //     const renderedBlocks = contentState?.blocks.map((block, i) => {
  //       const text = block.text;
  //       const parts = text.split(/(\s+)/).map((part, index) => {
  //         const isEnglish = /[a-zA-Z]/.test(part);
  //         return (
  //           <span
  //             dir={isEnglish ? 'ltr' : 'rtl'}
  //             style={{ display: 'inline-block', marginRight: '2px' }}
  //             key={index}
  //           >
  //             {part}
  //           </span>
  //         );
  //       });
  //       return (
  //         <div key={i}>
  //           {' '}
  //           {questionindex + 1}.{parts}{' '}
  //         </div>
  //       );
  //     });
  //     return renderedBlocks;
  //   };
  const isCorrectAns = (option) => {
    let userAnsweredOption = option?.user_option_index; // user answered option
    let correctAnswer = Object.keys(option?.answers)[0];
    console.log(correctAnswer, 'this is correct answer', userAnsweredOption);

    if (userAnsweredOption == correctAnswer) {
      return true;
    }
    return false;
  };

  return (
    <div
      className='answer-sheet d-flex justify-content-center mt-5 align-items-center'
      style={{ flexDirection: 'column' }}
    >
      <div className='anssheetheader'>Answer Sheet</div>
      <div className='container d-flex row flex-wrap justify-content-center mt-5'>
        {answerSheetData.map((item, index) => {
          const isQnEnglish = isEnglish(item.question);
          return (
            <div
              className={
                'anskeybox ' +
                (isQnEnglish ? 'englishopt ' : '') +
                (!isCorrectAns(item) ? 'wronganswerbox' : '')
              }
              key={index}
            >
              {/* <div className='questiontxt'>
                {parse(draftToHtml(item?.question), {
                  decodeEntities: false,
                })}
              </div> */}

              {item?.image_question ? (
                <img src={apiConstants.imgUrl + item?.image_question} className='imagequestion' />
              ) : (
                <div className='questiontxt'>
                  {parse(draftToHtml(item?.question), {
                    decodeEntities: false,
                  })}
                </div>
              )}
              <div className='answerbox'>
                {item?.options.map((option, index) => {
                  const isUserAnswer = index === item?.user_option_index;

                  const isCorrectAnswer = index === parseInt(Object.keys(item?.answers)[0]);
                  return (
                    <div
                      className={
                        'answer ' +
                        (isUserAnswer
                          ? isCorrectAnswer
                            ? 'correctansweroption'
                            : 'wrongansweroption'
                          : isCorrectAnswer
                          ? 'correctansweroption'
                          : '')
                      }
                      key={index}
                    >
                      {`${index + 1}) ${option?.option}`}
                      {isCorrectAnswer && (
                        <img
                          src='/img/accept.png'
                          className={'correctanmocres ' + (isQnEnglish ? 'englishopticon' : '')}
                        />
                      )}
                      {isUserAnswer && !isCorrectAnswer && (
                        <img
                          src='/img/wrong.png'
                          className={'correctanmocres ' + (isQnEnglish ? 'englishopticon' : '')}
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
